// import React, {useState, useEffect, useRef} from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from 'react-router-dom';
// import { BaseUrl } from "../../../Actions/Base";
// import NoDataResponse from "../../../Components/NoDataResponse";

// const LiveFeed= ({}) => {
//     const dispatch = useDispatch();
//     const navigate = useNavigate();

//     const [summary, setSummary] = useState({});
//     const [tableData, setTableData] = useState([]);

//    useEffect(() => {
//     fetch(`${BaseUrl}/api/Analytics/GetDashboardData`)
//         .then(res => res.json())
//         .then(data => {
//         console.log("🔥 Dashboard API Response:", data); // 👈 full response

//         if (data.success) {
//             console.log("📊 Summary:", data.summary); // 👈 summary only
//             console.log("📋 Table Data:", data.tableData); // 👈 table data only

//             setSummary(data.summary);
//             setTableData(data.tableData);
//         }
//         })
//         .catch(err => console.log("❌ Error:", err));
//     }, []);

//     const uniqueData = React.useMemo(() => {
//         const seen = new Set();

//         return tableData.filter(item => {
//             const key = `${item.userId}-${item.event}-${item.time}`;

//             if (seen.has(key)) return false;

//             seen.add(key);
//             return true;
//         });
//     }, [tableData]);

//     return (
//         <div className="flex w-full flex-col gap-[40px] justify-center items-center mt-[40px]">

//             <div className="w-[90%] flex flex-wrap justify-center items-center gap-[20px]">
//                 <div className="w-[300px] h-[130px] rounded-[9px] bg-gradient-to-r from-white to-[#D6D8FF] shadow-[0px_0px_6px_#00000029] flex flex-col p-[25px] gap-[5px]">
//                     <p className="text-[18px] text-[#656565]">Total Visitors This Week</p>
//                     <p className="text-[32px] font-bold">{summary?.totalVisitorsThisWeek || 0}</p>
//                 </div>

//                 <div className="w-[300px] h-[130px] rounded-[9px] bg-gradient-to-r from-white to-[#D6D8FF] shadow-[0px_0px_6px_#00000029] flex flex-col p-[25px] gap-[10px]">
//                     <p className="text-[18px] text-[#656565]">Active Users</p>
//                     <p className="text-[32px] font-bold">{summary?.activeUsers || 0}</p>
//                 </div>

//                 <div className="w-[300px] h-[130px] rounded-[9px] bg-gradient-to-r from-white to-[#D6D8FF] shadow-[0px_0px_6px_#00000029] flex flex-col p-[25px] gap-[10px]">
//                     <p className="text-[18px] text-[#656565]">Total Events</p>
//                     <p className="text-[32px] font-bold">{summary?.monthlyEventsUsed || 0}</p>
//                 </div>

//                 <div className="w-[300px] h-[130px] rounded-[9px] bg-gradient-to-r from-white to-[#D6D8FF] shadow-[0px_0px_6px_#00000029] flex flex-col p-[25px] gap-[10px]">
//                     <p className="text-[18px] text-[#656565]">New Users</p>
//                     <p className="text-[32px] font-bold">{summary?.newUsers || 0}</p>
//                 </div>
//             </div>

//            <div className="w-[90%] rounded-[16px] py-[90px]"
//             style={{
//                     background: 'transparent linear-gradient(90deg, #FFFFFF 0%, #D6D8FF 100%) 0% 0% no-repeat padding-box',
//                     boxShadow: '0px 0px 12px #AEAEFE',
//                 }}>

//                 <table className="w-full text-left border-collapse">
//                     {/* Table Head */}
//                     <thead 
//                    >
//                         <tr className="text-[#FFFFFF] text-[19px] font-normal"
//                         style={{
//                             background:
//                                 'transparent linear-gradient(90deg, #7DEFFE 0%, #8773DC 100%) 0% 0% no-repeat padding-box',
//                             }}>
//                         <th className="px-2 py-3 w-[20%] text-center">User Email</th>
//                         <th className="text-center py-3 w-[20%] ">Date/Time</th>
//                         <th className="py-3 w-[10%] text-center">Contry-City</th>
//                         <th className="py-3 w-[20%] text-center">Page</th>
//                         <th className="text-center py-3 w-[10%]">Event Type</th>
//                         <th className="text-center py-3 w-[20%]">Message</th>
//                         </tr>
//                     </thead>

//                     <tbody>
//                         {uniqueData.length === 0 ? (
//                             <tr>
//                             <td colSpan="7" className="text-center py-10">
//                                 <NoDataResponse
//                                 topText="No Data Found"
//                                 // bottomText="Publish a blog to see it here"
//                                 />
//                             </td>
//                             </tr>
//                         ) : (
//                             uniqueData.map((item, index) => {
//                             const isOdd = index % 2 !== 0;

//                             return (
//                                 <tr
//                                 key={`${item.userId}-${item.time}`}
//                                 style={{
//                                     background: isOdd
//                                     ? "#F1F1F1"
//                                     : "transparent linear-gradient(90deg, #FFFFFF 0%, #D6D8FF 100%)",
//                                 }}
//                                 >
//                                 {/* Email */}
//                                 <td className="text-center py-3 text-[#174A84]">
//                                     {item.email || "—"}
//                                 </td>

//                                 {/* Date/Time */}
//                                 <td className="text-center py-3 text-[#174A84]">
//                                     {item.time
//                                     ? new Date(item.time).toLocaleString()
//                                     : "—"}
//                                 </td>

//                                 {/* Country - City */}
//                                 <td className="text-center py-3 text-[#174A84]">
//                                     {item.country || "—"} - {item.city || "—"}
//                                 </td>

//                                 {/* Page */}
//                                 <td className="text-center py-3 text-[#174A84]">
//                                     {item.page || "—"}
//                                 </td>

//                                 {/* Event */}
//                                 <td className="text-center py-3 text-[#174A84]">
//                                     {item.event}
//                                 </td>

//                                 {/* Message (Custom Logic) */}
//                                 <td className="text-center py-3 text-[#174A84]">
//                                     {item.event === "$pageview"
//                                     ? "Visited Page"
//                                     : item.event === "$set"
//                                     ? "User Updated"
//                                     : item.event}
//                                 </td>
//                                 </tr>
//                             );
//                             })
//                         )}
//                     </tbody>

//                 </table>

//            </div>
//         </div>
//     );
// };

// export default LiveFeed;




import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { BaseUrl } from "../../../Actions/Base";
import NoDataResponse from "../../../Components/NoDataResponse";
import moment from 'moment';
import Pagination from "../../../Components/ReuseablePagination/Pagination";

const LiveFeed = ({appliedFilters}) => {
    const [summary, setSummary] = useState({});
    const [tableData, setTableData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);

    // const fetchData = (page) => {
    //     setLoading(true);
    //     fetch(`${BaseUrl}/api/Analytics/GetDashboardData?page=${page}&limit=200`)
    //         .then(res => res.json())
    //         .then(data => {
    //             if (data.success) {
    //                 setSummary(data.summary);
    //                 setTableData(data.tableData);
    //                 setCurrentPage(data.pagination.currentPage);
    //                 setTotalPages(data.pagination.totalPages);
    //                 setTotalRows(data.pagination.totalRows);
    //             }
    //         })
    //         .catch(err => console.log("❌ Error:", err))
    //         .finally(() => setLoading(false));
    // };

    const fetchData = (page) => {
    setLoading(true);

    const params = new URLSearchParams({ page, limit: 200 });

    if (appliedFilters?.Email?.trim())  params.append('email',    appliedFilters.Email.trim());
    if (appliedFilters?.FromDate)       params.append('fromDate', moment(appliedFilters.FromDate).toISOString());
    if (appliedFilters?.ToDate)         params.append('toDate',   moment(appliedFilters.ToDate).toISOString());

    fetch(`${BaseUrl}/api/Analytics/GetDashboardData?${params.toString()}`)
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                setSummary(data.summary);
                setTableData(data.tableData);
                setCurrentPage(data.pagination.currentPage);
                setTotalPages(data.pagination.totalPages);
                setTotalRows(data.pagination.totalRows);
            }
        })
        .catch(err => console.log("❌ Error:", err))
        .finally(() => setLoading(false));
    };

    // Re-fetch when appliedFilters change, reset to page 1
    useEffect(() => {
        fetchData(1);
    }, [appliedFilters]);

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        fetchData(page);
    };

    return (
        <div className="flex w-full flex-col gap-[40px] justify-center items-center mt-[40px]">

            {/* Summary Cards — unchanged */}
            <div className="w-[90%] flex flex-wrap justify-center items-center gap-[20px]">
                <div className="w-[300px] h-[130px] rounded-[9px] bg-gradient-to-r from-white to-[#D6D8FF] shadow-[0px_0px_6px_#00000029] flex flex-col p-[25px] gap-[5px]">
                    <p className="text-[18px] text-[#656565]">Total Visitors This Week</p>
                    <p className="text-[32px] font-bold">{summary?.totalVisitorsThisWeek || 0}</p>
                </div>
                <div className="w-[300px] h-[130px] rounded-[9px] bg-gradient-to-r from-white to-[#D6D8FF] shadow-[0px_0px_6px_#00000029] flex flex-col p-[25px] gap-[10px]">
                    <p className="text-[18px] text-[#656565]">Active Users</p>
                    <p className="text-[32px] font-bold">{summary?.activeUsers || 0}</p>
                </div>
                <div className="w-[300px] h-[130px] rounded-[9px] bg-gradient-to-r from-white to-[#D6D8FF] shadow-[0px_0px_6px_#00000029] flex flex-col p-[25px] gap-[10px]">
                    <p className="text-[18px] text-[#656565]">Total Events</p>
                    <p className="text-[32px] font-bold">{summary?.monthlyEventsUsed || 0}</p>
                </div>
                <div className="w-[300px] h-[130px] rounded-[9px] bg-gradient-to-r from-white to-[#D6D8FF] shadow-[0px_0px_6px_#00000029] flex flex-col p-[25px] gap-[10px]">
                    <p className="text-[18px] text-[#656565]">New Users</p>
                    <p className="text-[32px] font-bold">{summary?.newUsers || 0}</p>
                </div>
            </div>

            {/* Table */}
            <div className="w-[90%] rounded-[16px] py-[90px]"
                style={{
                    background: 'transparent linear-gradient(90deg, #FFFFFF 0%, #D6D8FF 100%) 0% 0% no-repeat padding-box',
                    boxShadow: '0px 0px 12px #AEAEFE',
                }}>

                {loading ? (
                    <p className="text-center text-[#656565] text-[18px]">Loading...</p>
                ) : (
                    <table className="w-full text-left border-collapse">
                        <thead>
                            <tr className="text-[#FFFFFF] text-[19px] font-normal"
                                style={{
                                    background: 'transparent linear-gradient(90deg, #7DEFFE 0%, #8773DC 100%) 0% 0% no-repeat padding-box',
                                }}>
                                <th className="px-2 py-3 w-[20%] text-center">User Email</th>
                                <th className="text-center py-3 w-[20%]">Date/Time</th>
                                <th className="py-3 w-[10%] text-center">Country-State-City-Postal Code</th>
                                <th className="py-3 w-[20%] text-center">Page</th>
                                <th className="text-center py-3 w-[10%]">Event Type</th>
                                <th className="text-center py-3 w-[20%]">Message</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.length === 0 ? (
                                <tr>
                                    <td colSpan="6" className="text-center py-10">
                                        <NoDataResponse topText="No Data Found" />
                                    </td>
                                </tr>
                            ) : (
                                tableData.map((item, index) => {
                                    const isOdd = index % 2 !== 0;
                                    return (
                                        <tr key={`${item.userId}-${item.time}-${index}`}
                                            style={{
                                                background: isOdd
                                                    ? "#F1F1F1"
                                                    : "transparent linear-gradient(90deg, #FFFFFF 0%, #D6D8FF 100%)",
                                            }}>
                                            <td className="text-center py-3 text-[#174A84]">{item.email || "—"}</td>
                                            <td className="text-center py-3 text-[#174A84]">{item.time ? new Date(item.time).toLocaleString() : "—"}</td>
                                            <td className="text-center py-3 text-[#174A84]">{item.country || "—"} - {item.region || "—"} - {item.city || "—"} - {item.postalCode || "—"} </td>
                                            <td className="text-center py-3 text-[#174A84]">{item.page || "—"}</td>
                                            <td className="text-center py-3 text-[#174A84]">{item.event}</td>
                                            <td className="text-center py-3 text-[#174A84]">
                                                {item.event === "$pageview" ? "Visited Page"
                                                    : item.event === "$set" ? "User Updated"
                                                    : item.event}
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                )}

                {/* Pagination Controls */}
                {/* {totalPages > 1 && (
                    <div className=" w-[95%] flex justify-end items-center flex-wrap gap-[10px] mt-[40px]">
                        <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="px-[16px] py-[8px] rounded-[8px] text-white font-medium disabled:opacity-40"
                            style={{ background: 'linear-gradient(90deg, #7DEFFE 0%, #8773DC 100%)' }}>
                            Prev
                        </button>

                        {/* Page Numbers */}
                        {/* {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                            <button
                                key={page}
                                onClick={() => handlePageChange(page)}
                                className="px-[14px] py-[8px] rounded-[8px] font-medium"
                                style={{
                                    background: page === currentPage
                                        ? 'linear-gradient(90deg, #7DEFFE 0%, #8773DC 100%)'
                                        : '#FFFFFF',
                                    color: page === currentPage ? '#FFFFFF' : '#174A84',
                                    border: '1px solid #8773DC'
                                }}>
                                {page}
                            </button>
                        ))} 
                        {(() => {
                            const pages = [];

                            if (totalPages <= 4) {
                                for (let i = 1; i <= totalPages; i++) pages.push(i);
                            } else {
                                if (currentPage <= 3) {
                                    // Show 1 2 3 ... 13
                                    pages.push(1, 2, 3, '...', totalPages);
                                } else if (currentPage >= totalPages - 2) {
                                    // Near the end: show 1 ... 11 12 13
                                    pages.push(1, '...', totalPages - 2, totalPages - 1, totalPages);
                                } else {
                                    // Middle: show 1 ... 5 6 7 ... 13
                                    pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...end', totalPages);
                                }
                            }

                            return pages.map((page, idx) =>
                                typeof page === 'string' && page.startsWith('...') ? (
                                    <span key={`ellipsis-${idx}`} className="px-[14px] py-[8px] text-[#174A84] font-medium">
                                        ...
                                    </span>
                                ) : (
                                    <button
                                        key={`page-${page}-${idx}`}
                                        onClick={() => handlePageChange(page)}
                                        disabled={page === currentPage}
                                        className="px-[14px] py-[8px] rounded-[8px] font-medium disabled:opacity-40"
                                        style={{
                                            background: page === currentPage
                                                ? 'linear-gradient(90deg, #7DEFFE 0%, #8773DC 100%)'
                                                : '#FFFFFF',
                                            color: page === currentPage ? '#FFFFFF' : '#174A84',
                                            border: '1px solid #8773DC'
                                        }}>
                                        {page}
                                    </button>
                                )
                            );
                        })()}

                        <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="px-[16px] py-[8px] rounded-[8px] text-white font-medium disabled:opacity-40"
                            style={{ background: 'linear-gradient(90deg, #7DEFFE 0%, #8773DC 100%)' }}>
                            Next
                        </button>
                    </div>
                )} */}

                {totalPages > 1 && (
                    <div className="w-[95%] mt-[40px] flex justify-end items-center">
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    </div>
                )}

                {/* Row count info */}
                <p className="w-[95%] flex justify-end text-center text-[#656565] mt-[15px] text-[14px]">
                    Showing {((currentPage - 1) * 200) + 1}–{Math.min(currentPage * 200, totalRows)} of {totalRows} rows
                </p>
            </div>
        </div>
    );
};

export default LiveFeed;
